import {Link} from "react-router-dom";

const Card = ({image, text, side, title, id,sectionName})=>{
    return(
        <>
            <div className={`card ${side}`} id={id}>
                <Link to={`/${sectionName}/${id}`}>
                    <div className="card-image">
                         <img className="card-img-top" src={image} alt=""/>
                    </div>
                </Link>
                <div className="card-body">
                    <h2>{title}</h2>
                    {text}
                </div>

                <button className="button button-card"> <Link to={`/${sectionName}/${id}`}>ir</Link></button>

            </div>
        </>
    )
}

export default Card;